
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[profileuser]",
      function () {
        return require("private-next-pages/[profileuser]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[profileuser]"])
      });
    }
  